import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Icons } from '@/theme/Images'
import { Button } from '@/components/index'
import { ExtendedTooltip } from '@/components'
import { Skeleton } from '@/components/ui/skeleton'
import { ROUTE_PAYMENTS, ROUTE_PAYMENTS_MAKE_PAYMENT } from '../../routes/paths'

const AccountSummarySkeleton = () => {
  const [isHovered, setIsHovered] = useState('')

  const renderStatementSkeleton = () => (
    <div className="flex flex-row justify-between gap-4 max-md:flex-col max-md:gap-1 w-full">
      {/* Payment Due */}
      <div className="flex flex-col max-md:flex-row-reverse max-md:justify-between max-md:w-full">
        <Skeleton className="w-24 h-6" data-testid="balance-field-sk" />
        <Skeleton className="w-20 h-4 mt-2 max-md:mt-0" data-testid="balance-field-sk" />
      </div>

      <div className="flex flex-row gap-6">
        <div className="w-[1px] h-[45px] bg-neutral-200 max-md:hidden" />
        <div className="flex flex-col max-md:flex-row-reverse max-md:justify-between max-md:w-full">
          <Skeleton className="w-24 h-6" data-testid="balance-field-sk" />
          <div className="flex items-center">
            <Skeleton className="w-24 h-4" data-testid="balance-field-sk" />
            <img
              src={isHovered === 'minimum-payment' ? Icons.helpBoldIcon : Icons.helpIcon}
              className="cursor-pointer ml-2 opacity-50"
              width={13.5}
              onMouseEnter={() => setIsHovered('minimum-payment')}
              onMouseLeave={() => setIsHovered('')}
            />
          </div>
        </div>
      </div>

      <div className="flex flex-row gap-6">
        <div className="w-[1px] h-[45px] bg-neutral-200 max-md:hidden" />
        <div className="flex flex-col max-md:flex-row-reverse max-md:justify-between max-md:w-full">
          <Skeleton className="w-24 h-6" data-testid="balance-field-sk" />
          <div className="flex items-center">
            <Skeleton className="w-28 h-4" data-testid="balance-field-sk" />
            <img
              src={isHovered === 'statement-balance' ? Icons.helpBoldIcon : Icons.helpIcon}
              className="cursor-pointer ml-2 opacity-50"
              width={13.5}
              onMouseEnter={() => setIsHovered('statement-balance')}
              onMouseLeave={() => setIsHovered('')}
            />
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div data-testid="right-column">
      <div className="top-content w-full border-b-dGray-200 border-b-[1px] px-6 py-8 flex flex-col gap-6">
        <div className="w-full flex flex-col md:flex-row md:flex-wrap justify-between gap-2">
          {/* Current Balance Skeleton */}
          <div className="flex flex-col">
            <div className="flex flex-row justify-start items-center">
              <p className="font-inter font-semibold text-base leading-7 text-neutral-900 tracking-normal">
                Current Balance
              </p>
              <ExtendedTooltip
                trigger={<img src={Icons.helpIcon} className="cursor-pointer ml-2 opacity-50" width={13.5} />}
                title={'Current Balance'}
                content="The total balance on your account, including all posted purchases, fees, and interest, minus any payments or credits."
              />
            </div>
            <Skeleton className="w-32 h-10 mt-2" data-testid="balance-field-sk" />
            <Skeleton className="w-40 h-4 mt-2" data-testid="balance-field-sk" />
          </div>

          {/* Mobile Statement Info */}
          <div className="mt-4 w-full md:hidden">{renderStatementSkeleton()}</div>

          {/* Right-side Buttons */}
          <div className="flex flex-col justify-start max-w-34 max-md:w-full pt-2 gap-2">
            <Link to={`/${ROUTE_PAYMENTS}${ROUTE_PAYMENTS_MAKE_PAYMENT}`} className="w-full mt-4 md:mt-0 mb-1">
              <Button className="w-full bg-brand-600 hover:bg-brand-700 text-sm text-white" disabled>
                Make Payment
              </Button>
            </Link>
            <Skeleton className="w-32 h-5 mt-3" data-testid="balance-field-sk" />
          </div>

          {/* Desktop Statement Info */}
          <div className="mt-4 w-full max-md:hidden">{renderStatementSkeleton()}</div>
        </div>
      </div>
    </div>
  )
}

export default AccountSummarySkeleton
